module.exports = __webpack_public_path__ + "static/media/PKO_Regular.a3470a5f.woff2";